// @ts-check

/**
 * Safely parse a JSON array parameter from a string.
 *
 * @param {string} param - The JSON string to parse.
 * @param {Array} [defaultValue=[]] - Default value to return if parsing fails.
 * @returns {Array} - The parsed array or the default value.
 */
export function parseJsonArrayParam(param, defaultValue = []) {
  try {
    if (!param) return defaultValue;
    const parsed = JSON.parse(param);
    return Array.isArray(parsed) ? parsed : defaultValue;
  } catch (e) {
    return defaultValue;
  }
}

/**
 * Safely parse the first element of a JSON array parameter.
 *
 * @param {string} param - The JSON string to parse.
 * @param {*} [defaultValue] - Fallback value if parsing fails or empty array.
 * @returns {*} - The first element of the parsed array or defaultValue.
 */
export function parseJsonFirstParam(param, defaultValue = null) {
  const parsed = parseJsonArrayParam(param, []);
  return parsed.length ? parsed[0] : defaultValue;
}

/**
 * Extracts a location slug from a stop ID string.
 *
 * @param {string} stopId - The stop ID string, e.g., "CDS_67_65".
 * @returns {string|null} - The extracted slug, null if not available, or the original stopId if format doesn't match.
 */
export function extractSlugFromStopId(stopId) {
  if (!stopId) return null;
  const parts = stopId.split('_');
  if (parts.length >= 2) {
    return parts[1];
  }
  return stopId;
}
